import { useInfiniteQuery } from '@tanstack/react-query';
import { ICompanyAggregateActivity, ImpersonationBroker, IPagedCollection } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'reports/company/byTags';

export function useReportsCompanyByTagsQuery({
	enabled,
	endDate,
	startDate,
	tags,
	userId,
	pageSize = 25,
}: {
	enabled?: boolean;
	endDate: Date;
	startDate: Date;
	tags: string[];
	userId?: string;
	pageSize?: number;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryKey: [BASE_QUERY_KEY, endDate, startDate, tags, userId, pageSize],
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<ICompanyAggregateActivity>>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `reports/company/byTags`,
					queryParams: {
						pageSize,
						pageToken: pageParam,
					},
				}),
				'POST',
				{ endDate, startDate, tags, userId }
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
	});
}
